import { configureDatabase } from "../../main/data/data-read-only";
import { getListOfSongs } from "./getListOfSongs";
import { initUI } from "./initUI";
import { initialHTML } from "./initialHTML";
import { organizeSongs } from "./organizeSongs";
import { searchSongListEvent } from "./searchSongListEvent";
document.addEventListener("DOMContentLoaded", () => {
    initialHTML();
    configureDatabase();
    getListOfSongs()
        .then(organizeSongs)
        .then((songHistory) => {
        document.addEventListener("keyup", (e) => searchSongListEvent(songHistory, e));
        initUI(songHistory, songHistory.songs);
    });
});
